import React, { Fragment, useState, useEffect } from "react";
import "moment-timezone";
import { Dropdown, OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import axiosInstance from "../../utils/axiosInstance";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import "./Tickets.css";
import PdfFileIcon from "../../assests/img/pdf-file-icon.svg";
import AvtarUserIcon from "../../assests/img/avatar-user-icon.svg";
import CompanyIcon from "../../assests/img/comp-icon.svg";
import CallIcon from "../../assests/img/call-icon.svg";
import MailIcon from "../../assests/img/mail-icon.svg";
import moment from "moment";
import CriticalIcon from "../../assests/img/critical-icon.svg";
import E1Icon from "../../assests/img/E1-icon.svg";
import E2Icon from "../../assests/img/E2-icon.svg";
import E3Icon from "../../assests/img/E3-icon.svg";
import OverdueIcon from "../../assests/img/overdue-icon.svg";
import ReOpenIcon from "../../assests/img/menu/reopen.png";
import NextIconAttach from "../../assests/img/Next-Icon-attach.svg";
import PrevIconAttach from "../../assests/img/Prev-Icon-attach.svg";
import PencilIcon from "../../assests/img/pencil.svg";
import CSVIcon from "../../assests/img/csv.svg";
import XLSXIcon from "../../assests/img/xlsx.svg";
import PowerPointIcon from "../../assests/img/powerpoint.svg";
import VideoIcon from "../../assests/img/video.svg";
import DocIcon from "../../assests/img/doc.svg";
import ZipIcon from "../../assests/img/zip.svg";
import AddCommentIcon from "../../assests/img/AddComment_icon.svg";
import FootMenuIcon from "../../assests/img/Foot-menu-icon.svg";
import starIcon from "../../assests/img/Ratings/star-icon.svg";
import linkIcon from "../../assests/img/link-icon.svg";
import { toast } from "react-toastify";
import CustomForm from "../DynamicForm/CustomForm";
import DynamicForm from "../DynamicFormV2/DynamicForm";
import ReturnedTicketRedIcon from "../../assests/img/menu/ReturnedTicketRed.svg";
import AssignedToIcon from "../../assests/img/assigned.svg";
import NewCommentIcon from "../../assests/img/menu/newComment.png";

const Ticket = ({
  ticket,
  item,
  handleButtonClick,
  handleCriticalButtonClick,
  allData,
  escData,
  resetCommentBox,
  resetReassignBox,
  allTicketData,
  time,
  setTime,
  activeTabDet,
  setactiveTabDet,
  groupTypeOpExistAm,
  resetIrrelevantBox
}) => {
  const dueDate = moment(ticket?.dueDate).tz("Asia/Kolkata");
  const now = moment().tz("Asia/Kolkata");
  const [form, setForm] = useState({});
  const [initialValues, setInitialValues] = useState({});
  const [modifiedValues, setModifiedValues] = useState({});
  const [ticketId, setTicketId] = useState("");
  const [dueTime, setDueTime] = useState(null);
  const [statusTimeAnalysis, setStatusTimeAnalysis] = useState([]);
  const [departmentTimeAnalysis, setDepartmentTimeAnalysis] = useState([]);
  const [isCopied, setIsCopied] = useState(false);

  let dueText;
  if (dueDate.isSame(now, "day")) {
    dueText = `Due by ${dueDate.format("hh:mm A")}`;
  } else if (dueDate.isSame(now.clone().subtract(1, "day"), "day")) {
    dueText = "Due by yesterday";
  } else if (dueDate.isSame(now.clone().add(1, "day"), "day")) {
    dueText = "Due by tomorrow";
  } else if (dueDate.isAfter(now, "day")) {
    dueText = `Due by ${dueDate.format("DD MMM")}`;
  } else {
    dueText = `Due by ${dueDate.format("DD MMM")}`;
  }

  const [selectedStatus, setSelectedStatus] = useState("");

  const handleCopyUrl = () => {
    const url = new URL(`/ticket-lists`, window.location.origin);
    url.searchParams.set("ticketNumber", ticket.ticketNumber);

    navigator.clipboard
      .writeText(url)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      })
      .catch((err) => {
        console.error("Failed to copy the text: ", err);
      });
  };
  // Update selectedStatus when ticket is available
  useEffect(() => {
    if (ticket && ticket.status) {
      setSelectedStatus(ticket.status);
    }
  }, [ticket]);

  let groupTypeValue = "";
  if (ticket !== null && ticket !== undefined) {
    for (const e of ticket.assignee) {
      if (e.stage === ticket.currentStage) {
        groupTypeValue = e.groupType;
        break;
      }
    }
  }

  let buttonValues = [];
  if (ticket !== null && ticket !== undefined) {
    buttonValues = ticket?.statusOption?.map((e) => e.statusLabel); // Extract all statuses
    //groupTypeValue = ticket.statusOption.length > 0 ? ticket.statusOption[0].groupType : "";
  }

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  function formatDateTime(dateTimeString) {
    const date = new Date(dateTimeString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // Add double spaces before and after the dash
    return `${day}-${month}-${year}  - ${hours}:${minutes}`;
  }

  // Step 2: Function to handle popup open/close
  const handlePopupOpen = () => {
    setIsPopupOpen(true);
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handlePopupClose = () => setIsPopupOpen(false);

  const Link = ({ id, children, title }) => (
    <OverlayTrigger overlay={<Tooltip id={id}>{title}</Tooltip>}>
      <a href="#!" className="ProgressPoint_Dot_TP">
        {children}
      </a>
    </OverlayTrigger>
  );

  const formatShowTime = (ticketStartTime) => {
    const showTime = moment(ticketStartTime).tz("Asia/Kolkata");
    const today = moment().tz("Asia/Kolkata");
    const yesterday = moment().tz("Asia/Kolkata").subtract(1, "days");

    if (showTime.isSame(today, "day")) {
      return showTime.format("h:mm A");
    } else if (showTime.isSame(yesterday, "day")) {
      return "Yesterday ";
    } else {
      return showTime.format("DD/MM/YY");
    }
  };

  const formatDate = (dateString) => {
    const date = moment(dateString);
    return date.format("Do MMMM YYYY, h:mm A");
  };

  const getFileName = (url) => {
    // Split the URL by '/' and get the last element
    const parts = url?.split("/");
    return parts[parts.length - 1];
  };

  const handleDropdownItemClick = (status) => {
    console.log(status, "jshagdjhasgdjhsd");
    setSelectedStatus(status);
    handleButtonClick(ticket._id, status);
  };

  // Attachement Viewer
  const [showViewer, setShowViewer] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentContainerIndex, setCurrentContainerIndex] = useState(0);

  const openViewer = (containerIndex, imageIndex) => {
    setCurrentContainerIndex(containerIndex);
    setCurrentIndex(imageIndex);
    setShowViewer(true);
  };

  const getMimeType = (url) => {
    const extension = url.split(".").pop();
    switch (extension) {
      case "pdf":
        return "application/pdf";
      case "docx":
        return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      case "heic":
        return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return `image/${extension}`;
      case "mp4":
        return "video/mp4";
      case "MP4":
        return "video/MP4";
      case "mov":
        return "video/mov";
      case "webm":
        return "video/webm";
      case "ppt":
        return "application/vnd.ms-powerpoint";
      case "csv":
        return "text/csv";
      case "xlsx":
        return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      case "zip":
        return "application/zip";
      default:
        return "png";
    }
  };

  const closeViewer = () => {
    setShowViewer(false);
  };

  const showNextImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === allData[currentContainerIndex]?.attachment.length - 1
        ? 0
        : prevIndex + 1
    );
  };

  const showPreviousImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0
        ? allData[currentContainerIndex]?.attachment.length - 1
        : prevIndex - 1
    );
  };

  const isNextImageValid = () => {
    const nextIndex = currentIndex + 1;
    const nextImage = allData[currentContainerIndex]?.attachment[nextIndex];
    if (!nextImage) return false;

    const validImageTypes = ["png", "jpg", "jpeg", "svg", "gif"];
    const nextImageType = nextImage.split(".").pop()?.toLowerCase();
    return validImageTypes.includes(nextImageType);
  };

  const isPreviousImageValid = () => {
    const prevIndex = currentIndex - 1;
    const prevImage = allData[currentContainerIndex]?.attachment[prevIndex];
    if (!prevImage) return false;

    const validImageTypes = ["png", "jpg", "jpeg", "svg", "gif"];
    const prevImageType = prevImage.split(".").pop()?.toLowerCase();
    return validImageTypes.includes(prevImageType);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        closeViewer();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [closeViewer, showNextImage, showPreviousImage]);

  const getFilenameFromUrl = (url) => {
    try {
      // Ensure URL is fully qualified
      if (!url.startsWith("http")) {
        throw new Error("Invalid URL format");
      }

      const parsedUrl = new URL(url);
      const pathname = parsedUrl.pathname;
      const segments = pathname.split("/");
      return segments.pop(); // Get the last segment (filename)
    } catch (error) {
      console.error("Error extracting filename:", error.message);
      return null;
    }
  };

  const extractFloor = (text) => {
    const regex = /^([\d\w]+.*Floor)/;
    const match = text.match(regex);
    if (match) {
      return match[0];
    } else {
      return null;
    }
  };

  const removeTextAfterComma = (text) => {
    const commaIndex = text.indexOf(",");
    return commaIndex !== -1 ? text.substring(0, commaIndex) : text;
  };

  // Ticket Details Overview Tabs
  const handleTabDetClick = async (tab, id) => {
    console.log("asdfghsdfg", tab);
    setactiveTabDet(tab);
    setTicketId(id);

    if (tab === "slaBreakdownTab") {
      try {
        // Make the API request to the cURL endpoint
        const response = await axiosInstance.get("ticket/statusTimeAnalysis", {
          params: { ticketId: id }, // Dynamically passing the ticketId
        });

        // Handle the response
        if (response.data.statusValue === 200) {
          const { dueTime, statusTimeAnalysis, departmentTimeAnalysis } =
            response.data;

          // Update the state with the fetched data
          setDueTime(dueTime);
          setStatusTimeAnalysis(statusTimeAnalysis);
          setDepartmentTimeAnalysis(departmentTimeAnalysis);
          // Process the response data as needed here
        } else {
          console.error("Unexpected API response status:", response.status);
        }
      } catch (error) {
        console.error("Error calling the API:", error);
      }
    }
  };
  // Using useEffect to track changes in initialValues and update modifiedValues
  // useEffect(() => {
  //   if (initialValues) {
  //     setModifiedValues(initialValues); // When initialValues change, update modifiedValues
  //   }
  // }, [initialValues]);

  function restructureKeyValue(formInfo) {
    const newFormInfo = {};

    for (const key in formInfo) {
      const parts = key.split(".");
      let current = newFormInfo;

      parts.reduce((acc, part, index) => {
        if (index === parts.length - 1) {
          acc[part] = formInfo[key];
        } else {
          if (!acc[part]) acc[part] = {};
          return acc[part];
        }
        return acc;
      }, newFormInfo);
    }

    return newFormInfo;
  }

  const getModifiedFields = (initialValues, submittedValues) => {
    const result = {};

    for (let key in submittedValues) {
      if (submittedValues.hasOwnProperty(key)) {
        const submittedValue = submittedValues[key];
        const initialValue = initialValues[key];

        if (submittedValue && typeof submittedValue === "object") {
          if ("value" in submittedValue && "label" in submittedValue) {
            // If it's a dropdown field, include only the `value`
            if (submittedValue.value !== initialValue?.value) {
              result[key] = submittedValue.value; // Send only `value`
            }
          } else {
            // Recursively process nested objects
            const nestedFields = getModifiedFields(
              initialValue || {},
              submittedValue
            );
            if (Object.keys(nestedFields).length > 0) {
              result[key] = nestedFields;
            }
          }
        } else if (
          submittedValue !== initialValue && // Field value is modified
          (submittedValue !== "" || initialValue === undefined) // Either field is newly filled or explicitly set
        ) {
          result[key] = submittedValue;
        }
      }
    }

    return result;
  };

  return (
    <Fragment>
    {ticket !== null && ticket !== undefined ? (
        <div className="TicketDetailsSection">
          {/* Ticket Details Header */}
          <div
            className={`TicketDetailsSection_header ${
              ticket?.escalationStatus === "Critical"
                ? "Criticalticket_box"
                : ""
            }`}
          >
            <div className="TicketDetailsSection_headerLeft">
            {ticket?.newCommentForAssignee ?
              <div className="UnreadDot">
                <span></span>
              </div>
              : ""}
              <div
                className="ticketDetails_Avatar"
                style={{
                  backgroundColor:
                    groupTypeValue === "op"
                      ? "#A96AC2"
                      : groupTypeValue === "tc"
                      ? "#AF9C92"
                      : groupTypeValue === "it"
                      ? "#28467E"
                      : groupTypeValue === "am"
                      ? "#5D7F6C"
                      : groupTypeValue === "md"
                      ? "#A56C4B"
                      : groupTypeValue === "is"
                      ? "#5385D0"
                      : "",
                }}
              >
                {groupTypeValue}
              </div>
              <div className="ticketDetails_HeaderDetials">
                <div className="TicketTitle">
                  {" "}
                  <span>
                    {ticket.subCategoryId ? ticket.subCategoryId.category : ""}{" "}
                    <span className="Divider1">|</span> {""}
                  </span>
                  <span>
                    {ticket.subCategoryId
                      ? ticket.subCategoryId.subCategory
                      : ""}
                  </span>
                  {/* {ticket.isCritical ? (
                    <span className="IsCriticalBadge">
                      <img src={CriticalIcon} />
                    </span>
                  ) : (
                    ""
                  )} */}
                  {ticket?.escalationStatus === "Critical" ? (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-Critical`}>Critical</Tooltip>
                      }
                    >
                      <span className="TT_Badge IsCriticalBadge">
                        <img src={CriticalIcon} />
                      </span>
                    </OverlayTrigger>
                  ) : ticket?.escalationStatus == "Over Due" ? (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-OverDue`}>Overdue</Tooltip>
                      }
                    >
                      <span className="TT_Badge InprogressIcon">
                        <img src={OverdueIcon} alt="" />
                      </span>
                    </OverlayTrigger>
                  ) : ticket?.escalationStatus == "E1" ? (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-E1`}>Escalation Level 1</Tooltip>
                      }
                    >
                      <span className="TT_Badge CriticalLevelBadge">
                        <img src={E1Icon} alt="" />
                      </span>
                    </OverlayTrigger>
                  ) : ticket?.escalationStatus == "E2" ? (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-E2`}>Escalation Level 2</Tooltip>
                      }
                    >
                      <span className="TT_Badge CriticalLevelBadge">
                        <img src={E2Icon} alt="" />
                      </span>
                    </OverlayTrigger>
                  ) : ticket?.escalationStatus == "E3" ? (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-E3`}>Escalation Level 3</Tooltip>
                      }
                    >
                      <span className="TT_Badge CriticalLevelBadge">
                        <img src={E3Icon} alt="" />
                      </span>
                    </OverlayTrigger>
                  ) : ticket?.escalationStatus == "Reopen" ? (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-Reopen`}>Re-opened</Tooltip>
                      }
                    >
                      <span className="TT_Badge CriticalLevelBadge">
                        <img src={ReOpenIcon} alt="" />
                      </span>
                    </OverlayTrigger>
                  ) : ticket?.escalationStatus == "Returned" ? (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-OverDue`}>Returned</Tooltip>
                      }
                    >
                      <span className="TT_Badge InprogressIcon">
                        <img src={ReturnedTicketRedIcon} alt="" />
                      </span>
                    </OverlayTrigger>
                  ) : (
                    ""
                  )}
                  <span
                    onClick={handleCopyUrl}
                    style={{ cursor: "pointer", display: "inline-flex" }}
                  >
                    {isCopied ? (
                      <span
                        className="position-relative"
                        style={{
                          fontSize: "10px",
                          fontWeight: "400",
                          top: "-3px",
                          lineHeight: "normal",
                        }}
                      >
                        Copied!
                      </span>
                    ) : (
                      <img src={linkIcon} alt="" />
                    )}
                  </span>
                </div>

                <div className="TicketLocation">
                  {" "}
                  {ticket.companyName} 
                  {/* -{" "}
                  {extractFloor(ticket?.floor) === null
                    ? ticket?.floor + " " + "Floor"
                    : extractFloor(ticket?.floor)}{" "}
                  - {removeTextAfterComma(ticket.locationId.locationName)} */}
                   {extractFloor(ticket?.floor) === null 
                    ? ""
                    :  " - " + extractFloor(ticket?.floor)}{" "}
                  - {removeTextAfterComma(ticket.locationId.locationName)}
                </div>
                <div className="Ticket_OtherInfo">
                  <span>
                    {ticket?.ticketType?.charAt(0)?.toUpperCase() +
                      ticket?.ticketType?.slice(1)}
                  </span>
                  <span>#{ticket.ticketNumber}</span>

                  {ticket?.status === "Done" ? (
                    ticket.rating ? (
                      <span className="RatingStars">
                        {[...Array(ticket.rating)].map((_, i) => (
                          <img key={i} src={starIcon} alt="" />
                        ))}
                      </span>
                    ) : (
                      ""
                    )
                  ) : (
                    <span>{dueText}</span>
                  )}
                </div>

                {/* Assigned to content start */}


                {allTicketData?.pendingWith && allTicketData?.pendingWith?.length > 0 ? (
                
                <div className="AssignedTo">
                  <div className="AssignedTooltipTigger">
                    <img src={AssignedToIcon} alt="Assigned To Icon" style={{ cursor: 'pointer' }} />

                    {allTicketData?.pendingWith.length > 1 && (
                    <div className="AssignedTooltip_Container_V2">
                     
                          
                            <div className="AssignedTooltip">
                            {allTicketData?.pendingWith?.slice(1).map((person, index) => (
                              
                                <div className="AssignedTooltip_Names" key={index}>{person?.name}</div>
                              
                            ))}
                            </div>
                    </div>
                      )}
                  

                    <span>Assigned to: </span>

                    {allTicketData?.pendingWith && allTicketData?.pendingWith?.length > 0 && (
                      <>
                        <span>{allTicketData.pendingWith[0]?.name}</span>
                        {allTicketData?.pendingWith?.length > 1 && (
                          <>
                            <span>+</span>
                            <span className="OtherAssigned">
                              {allTicketData?.pendingWith?.length - 1} others
                            </span>
                          </>
                        )}
                      </>
                    )}

                  </div>
                </div> ) : "" }

                {/* Assigned to content end */}

                <div className="HeaderCustomTabs">
                  <a
                    role="button"
                    className={activeTabDet === "overview" ? "ActiveTab" : ""}
                    onClick={() => handleTabDetClick("overview")}
                  >
                    OVERVIEW
                  </a>

                  {/* {activeTabDet === 'details' && ( */}
                  {/*  Start Customizable form condition */}

                  {allTicketData?.hasDetails &&
                  (ticket?.isAssignee === undefined ||
                    ticket?.isAssignee === true) ? (
                    <a
                      role="button"
                      className={activeTabDet === "details" ? "ActiveTab" : ""}
                      onClick={() =>
                        handleTabDetClick("details", allTicketData?._id)
                      }
                    >
                      Details
                    </a>
                  ) : (
                    ""
                  )}

                  {/*  End Customizable form condition */}

                  {ticket?.isAssignee === undefined ||
                  ticket?.isAssignee === true
                    ? allTicketData?.internalSla && (
                        <a
                          role="button"
                          className={
                            activeTabDet === "slaBreakdownTab"
                              ? "ActiveTab"
                              : ""
                          }
                          onClick={() =>
                            handleTabDetClick(
                              "slaBreakdownTab",
                              allTicketData?._id
                            )
                          }
                        >
                          Time Analysis
                        </a>
                      )
                    : ""}
                </div>
              </div>
            </div>

            <div className="TicketDetailsSection_headerRight">
              <div className="TicketTime">
                {formatShowTime(ticket.startTime)}
              </div>
              <div className="HeaderTicketActon">
                <Dropdown>
                  {/* <Dropdown.Toggle variant="" className={selectedStatus}>
                    {selectedStatus} */}
                  <Dropdown.Toggle variant="" className={ticket?.status}>
                    {ticket?.statusOption?.find(
                      (opt) => opt?.status === ticket?.status
                    )?.statusLabel ||
                      (ticket?.status === "Reopen"
                        ? "Reopened"
                        : ticket?.status)}
                  </Dropdown.Toggle>
                  {buttonValues?.length > 0 ? (
                    <Dropdown.Menu>
                      {buttonValues?.map((statusLabel, index) => (
                        <Dropdown.Item
                          key={index}
                          href="#"
                          onClick={() =>
                            handleButtonClick(
                              ticket._id,
                              ticket.statusOption[index].status
                            )
                          }
                        >
                          {statusLabel}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  ) : (
                    ""
                  )}
                </Dropdown>
              </div>
            </div>
          </div>

          <div className="TicketDetailsSection_Body">
            {/* Horizontal Timeline */}
            {/* <div className="TicketProgressContainer">
              <div className="TicketProgressBar">
                <ul>
                  {escData.map((item, index) => (
                    <li key={index} className={item.reached === true ? 'Point_Achieved' : ''}>
                      <div className="TicketProgressBar_Point">
                        <div className="ProgressPoint_Title">{item.name}</div>

                        <Link title={item.escalationHours} id={`t-${index}`} className="ProgressPoint_Dot">&nbsp;</Link>

                        <div className="ProgressPoint_Time">  {moment(item.date)
                          .tz("Asia/Kolkata")
                          .format("DD MMM, hh:mm A")}</div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div> */}

            {activeTabDet === "overview" && (
              <div className="OverviewTabContent">
                {ticket?.isAssignee === undefined ||
                ticket?.isAssignee === true ? (
                  <div className="TicketProgressContainer">
                    <div className="TicketProgressBar_Full">
                      <ul>
                        {escData?.map((item, index) => (
                          <li
                            key={index}
                            className={
                              item.reached === true ? "Point_Achieved" : ""
                            }
                          >
                            <div className="TicketProgressBar_Point">
                              <div className="ProgressPoint_Title">
                                {item.name}
                              </div>

                              <Link
                                title={item.escalationHours}
                                id={`t-${index}`}
                                className=""
                              >
                                <div className="DotInnerCircle"></div>
                              </Link>

                              <div className="ProgressPoint_Time">
                                {" "}
                                {moment(item.date)
                                  .tz("Asia/Kolkata")
                                  .format("DD MMM, hh:mm A")}
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {/* Ticket Feed */}
                {allData
                  ? allData.map((item, index) => (
                      <div className="TicketFeedContainer">
                        <div className="TicketFeedBox">
                          {/* <div className="ticketDetails_Avatar">SA</div> */}

                          <div className="ticketDetails_Avatar_container">
                            <div className="ticketDetails_Avatar">
                              <span>{item?.nameInitials}</span>
                              <div className="ticketDetails_Avatar_Info">
                                <div className="TooltipSpacePatch74"></div>
                                <div className="TooltipInfo_Row">
                                  <div className="Tooltip_Avatar">
                                    {item?.nameInitials}
                                  </div>
                                  <div className="Tooltip_Avatar_Name">
                                    {item?.fullName}
                                  </div>
                                </div>
                                <div className="TooltipInfo_Row">
                                  <div className="TooltipInfo_Icon">
                                    <img src={CompanyIcon} alt="" />
                                  </div>
                                  <div className="info">
                                    {item?.companyName}
                                  </div>
                                </div>
                                <div className="TooltipInfo_Row">
                                  <div className="TooltipInfo_Icon">
                                    <img src={MailIcon} alt="" />
                                  </div>
                                  <div className="info">{item?.email}</div>
                                </div>
                                <div className="TooltipInfo_Row mb-0">
                                  <div className="TooltipInfo_Icon">
                                    <img src={CallIcon} alt="" />
                                  </div>
                                  <div className="info">{item?.phone}</div>
                                </div>
                              </div>
                              <img
                                src={AvtarUserIcon}
                                className="ticketDetails_Avatar_icon"
                                alt=""
                              />
                            </div>
                          </div>

                          <div className="TicketFeedContent">
                            <div className="TicketFeedTitle">
                              <div className="TicketFeedTitle_content">
                                <strong>{item?.fullName}</strong>
                                <span>{item?.action} </span>
                                <span className="TicketFeedTitle_Star">
                                  {item?.rating > 0 && (
                                    <>
                                      {item?.rating}{" "}
                                      <img src={starIcon} alt="" width={12} />{" "}
                                      out of 5
                                    </>
                                  )}
                                </span>{" "}
                                {/* start Customizable form condition */}
                                {item?.moreInfo === true ? (
                                  <span>
                                    , view&nbsp;
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleTabDetClick(
                                          "details",
                                          allTicketData._id
                                        );
                                      }}
                                    >
                                      details
                                    </a>
                                  </span>
                                ) : (
                                  ""
                                )}
                                {/* end Customizable form condition */}.
                              </div>
                              <div className="TicketFeedTime">
                                {formatDate(item?.createdAt)}
                              </div>
                            </div>
                            <div className="TicketFeedName">
                              {item?.subject}
                            </div>
                            {/* you may use this to show subject in future refrence */}
                            <p>
                              {/* {item?.action === "created a ticket"
                                ? item?.description
                                : ""} */}
                              {item?.description?.trim() && (
                                <p>{item.description}</p>
                              )}
                            </p>
                            <div className="TicketFeedAttachement">
                              <div className="AttachedFiles">
                                {item?.attachment?.length !== 0 ? (
                                  <div className="AttachmentsCount">
                                    {/* {item?.attachment?.length} Attachments - */}
                                    {/* <i className="fa-solid fa-caret-down"></i> */}
                                    {item?.attachment?.length}{" "}
                                    {item?.attachment?.length === 1
                                      ? "Attachment -"
                                      : "Attachments -"}
                                  </div>
                                ) : (
                                  ""
                                )}

                                <div className="d-flex flex-wrap">
                                  {console.log(item.attachment,"attachmentssss")}
                                  {item.attachment &&
                                    item.attachment.map(
                                      (attachment, imageIndex) => (
                                        <div
                                          key={index}
                                          className="AttachedFileBox"
                                          style={{ margin: "5px" }}
                                        >
                                          <div className="AttachedFileView">
                                            {getMimeType(attachment) ===
                                            "application/pdf" ? (
                                              <div
                                                onClick={() =>
                                                  window.open(
                                                    attachment,
                                                    "_blank"
                                                  )
                                                }
                                              >
                                                <img
                                                  src={PdfFileIcon}
                                                  alt="PDF Attachment"
                                                  style={{ objectFit: "cover" }}
                                                />
                                                <div className="FileName1">
                                                  {getFilenameFromUrl(
                                                    attachment
                                                  )}
                                                </div>
                                              </div>
                                            ) : getMimeType(attachment) ===
                                              "application/zip" ? (
                                              <div
                                                onClick={() =>
                                                  window.open(
                                                    attachment,
                                                    "_blank"
                                                  )
                                                }
                                              >
                                                <img
                                                  src={ZipIcon}
                                                  alt="Zip Attachment"
                                                  style={{ objectFit: "cover" }}
                                                />
                                                <div className="FileName1">
                                                  {getFilenameFromUrl(
                                                    attachment
                                                  )}
                                                </div>
                                              </div>
                                            ) : getMimeType(attachment) ===
                                              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                                              <div
                                                onClick={() =>
                                                  window.open(
                                                    attachment,
                                                    "_blank"
                                                  )
                                                }
                                              >
                                                <img
                                                  src={XLSXIcon}
                                                  alt="XLXS Attachment"
                                                  style={{ objectFit: "cover" }}
                                                />
                                                <div className="FileName1">
                                                  {getFilenameFromUrl(
                                                    attachment
                                                  )}
                                                </div>
                                              </div>
                                            ) : getMimeType(attachment) ===
                                                "video/mp4" ||
                                              getMimeType(attachment) ===
                                                "video/MP4" ||
                                              getMimeType(attachment) ===
                                                "video/mov" ? (
                                              <div
                                                onClick={() =>
                                                  window.open(
                                                    attachment,
                                                    "_blank"
                                                  )
                                                }
                                              >
                                                <img
                                                  src={VideoIcon}
                                                  alt="Video Attachment"
                                                  style={{ objectFit: "cover" }}
                                                />
                                                <div className="FileName1">
                                                  {getFilenameFromUrl(
                                                    attachment
                                                  )}
                                                </div>
                                              </div>
                                            ) : getMimeType(attachment) ===
                                              "video/webm" ? (
                                              <div
                                                onClick={() =>
                                                  window.open(
                                                    attachment,
                                                    "_blank"
                                                  )
                                                }
                                              >
                                                <img
                                                  src={VideoIcon}
                                                  alt="Video Attachment"
                                                  style={{ objectFit: "cover" }}
                                                />
                                                <div className="FileName1">
                                                  {getFilenameFromUrl(
                                                    attachment
                                                  )}
                                                </div>
                                              </div>
                                            ) : getMimeType(attachment) ===
                                              "application/vnd.ms-powerpoint" ? (
                                              <div
                                                onClick={() =>
                                                  window.open(
                                                    attachment,
                                                    "_blank"
                                                  )
                                                }
                                              >
                                                <img
                                                  src={PowerPointIcon}
                                                  alt="Power Attachment"
                                                  style={{ objectFit: "cover" }}
                                                />
                                                <div className="FileName1">
                                                  {getFilenameFromUrl(
                                                    attachment
                                                  )}
                                                </div>
                                              </div>
                                            ) : getMimeType(attachment) ===
                                              "text/csv" ? (
                                              <div
                                                onClick={() =>
                                                  window.open(
                                                    attachment,
                                                    "_blank"
                                                  )
                                                }
                                              >
                                                <img
                                                  src={CSVIcon}
                                                  alt="CSV Attachment"
                                                  style={{ objectFit: "cover" }}
                                                />
                                                <div className="FileName1">
                                                  {getFilenameFromUrl(
                                                    attachment
                                                  )}
                                                </div>
                                              </div>
                                            ) : getMimeType(attachment) ===
                                              "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                                              <div
                                                onClick={() =>
                                                  window.open(
                                                    attachment,
                                                    "_blank"
                                                  )
                                                }
                                              >
                                                <img
                                                  src={DocIcon}
                                                  alt="Doc Attachment"
                                                  style={{ objectFit: "cover" }}
                                                />
                                                <div className="FileName1">
                                                  {getFilenameFromUrl(
                                                    attachment
                                                  )}
                                                </div>
                                              </div>
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  openViewer(index, imageIndex)
                                                }
                                              >
                                                <img
                                                  src={attachment}
                                                  alt=""
                                                  style={{
                                                    width: "60px",
                                                    height: "60px",
                                                    objectFit: "cover",
                                                  }}
                                                />
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  : ""}
                {/* Ticket Feed Ends */}
              </div>
            )}

            {activeTabDet === "details" && (
              <div className="DetailsTabContent">
                <Form className="d-none">
                  <div className="row mb-3">
                    <Form.Group as={Col} md={6} className="FormGroup">
                      <Form.Label className="formLabel">Type Text</Form.Label>
                      <Form.Control
                        className="formInput"
                        type="text"
                        placeholder="Placeholder..."
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={6} className="FormGroup">
                      <Form.Label className="formLabel">Type Select</Form.Label>
                      <Form.Select className="FormSelect">
                        <option>select menu</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group as={Col} md={12} className="FormGroup">
                      <Form.Label className="formLabel">
                        Checkbox Label
                      </Form.Label>
                      <Form.Check
                        type="checkbox"
                        label="Option 1"
                        id="custom-checkbox1"
                        className="DefaultFormCheck"
                      />
                      <Form.Check
                        type="checkbox"
                        label="Option 1"
                        id="custom-checkbox2"
                        className="DefaultFormCheck"
                      />
                      <Form.Check
                        type="checkbox"
                        label="Option 1"
                        id="custom-checkbox3"
                        className="DefaultFormCheck"
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={6} className="FormGroup">
                      <Form.Label className="formLabel">Type Number</Form.Label>
                      <Form.Control
                        className="formInput"
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        placeholder="Placeholder..."
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={6} className="FormGroup">
                      <Form.Label className="formLabel">Type Date</Form.Label>
                      <Form.Control
                        className="formInput"
                        type="date"
                        placeholder="Placeholder..."
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={6} className="FormGroup">
                      <Form.Label className="formLabel">Type Time</Form.Label>
                      <Form.Control
                        className="formInput"
                        type="time"
                        placeholder="Placeholder..."
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={12} className="FormGroup">
                      <Form.Label className="formLabel">
                        Type TextArea
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        className="formTextarea"
                        rows={3}
                        placeholder="Placeholder..."
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={12} className="FormGroup">
                      <Form.Label className="formLabel">
                        4 Attachments
                      </Form.Label>
                      <div className="D_AttachementFile">
                        <img
                          src="https://i.postimg.cc/bryY5MyZ/attachement.jpg"
                          alt=""
                        />
                        <img
                          src="https://api2.smartworksoffice.com/Upload/273ed8d5-44d6-4b2c-8c61-21440e49d1d1_DSC9263.jpg"
                          alt=""
                        />
                        <img
                          src="https://www.smartworksoffice.com/assets_html/images/RFID-Enabled-Parking.jpg"
                          alt=""
                        />
                        <img
                          src="https://www.smartworksoffice.com/assets_html/images/Tech-Enabled-Ecosystem.jpg"
                          alt=""
                        />
                      </div>
                    </Form.Group>
                  </div>
                </Form>

                {/* <CustomForm initialValues={initialValues} form={form}
                  handleSubmit={handleSubmit} // Pass the handleSubmit function here
                /> */}

                {/* <DynamicForm formConfig={formConfig} onSubmit={handleSubmit2} /> */}
                <DynamicForm
                  ticketId={ticket?._id}
                  status={ticket?.status}
                  //formData={apiResponse}
                />
              </div>
            )}

            {activeTabDet === "slaBreakdownTab" && (
              <div className="DetailsTabContent">
                <h6
                  style={{
                    fontSize: "15px",
                    fontWeight: "500",
                    marginBottom: "12px",
                  }}
                >
                  Client SLA -{" "}
                  <span style={{ fontWeight: "600" }}>{dueTime} hrs</span>
                </h6>
                {/* Second Table */}
                {departmentTimeAnalysis && departmentTimeAnalysis.length > 0 ? (
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="fw-semibold bg-body-secondary"
                        >
                          Dept
                        </th>
                        <th
                          scope="col"
                          className="fw-semibold bg-body-secondary"
                        >
                          Consumed SLA
                        </th>
                        <th
                          scope="col"
                          className="fw-semibold bg-body-secondary"
                        >
                          Allotted SLA
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {departmentTimeAnalysis.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.groupType?.toUpperCase()}</td>
                          <td>{item.consumedSla}</td>
                          <td>{item.budgetSla}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No data found for Department Time Analysis.</p>
                )}

                {/* First Table */}
                {statusTimeAnalysis && statusTimeAnalysis.length > 0 ? (
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="fw-semibold bg-body-secondary"
                        >
                          Dept
                        </th>
                        <th
                          scope="col"
                          className="fw-semibold bg-body-secondary"
                        >
                          From
                        </th>
                        <th
                          scope="col"
                          className="fw-semibold bg-body-secondary"
                        >
                          To
                        </th>
                        <th
                          scope="col"
                          className="fw-semibold bg-body-secondary"
                        >
                          Start Time
                        </th>
                        <th
                          scope="col"
                          className="fw-semibold bg-body-secondary"
                        >
                          End Time
                        </th>
                        <th
                          scope="col"
                          className="fw-semibold bg-body-secondary"
                        >
                          Duration
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {statusTimeAnalysis.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.groupType?.toUpperCase()}</td>
                          <td>{item.statusFrom}</td>
                          <td>{item.statusTo}</td>
                          <td style={{ whiteSpace: "pre" }}>
                            {formatDateTime(item.startTime)}
                          </td>
                          <td style={{ whiteSpace: "pre" }}>
                            {formatDateTime(item.endTime)}
                          </td>
                          <td>{item.duration}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No data found for Status Time Analysis.</p>
                )}
              </div>
            )}
          </div>

          {/* Ticket Detials Footer */}
          <div className="TicketDetailsSection_Footer">
            {activeTabDet === "overview" && (
              <>
                {allTicketData?.internalSla &&
                  Object.keys(allTicketData.internalSla).length > 0 && (
                    <div className="FooterInfoStrip">
                      <div className="d-flex align-items-center">
                        {allTicketData.clientStatus !== "Closed" ? (
                          <>
                            <div className="ticketDetails_Avatar">
                              {allTicketData.internalSla.groupType}
                            </div>
                            <div>
                              SLA for{" "}
                              {allTicketData?.internalSla?.groupType?.toUpperCase()}{" "}
                              team is {allTicketData.internalSla.budgetSla}{" "}
                              hours,{" "}
                              {allTicketData.internalSla.timeTick ? (
                                <span>{time} hours consumed</span>
                              ) : (
                                `${allTicketData.internalSla.consumedSla} hours consumed`
                              )}
                              .{" "}
                              <a
                                className="LearmoreLink"
                                href="#"
                                onClick={() =>
                                  handleTabDetClick(
                                    "slaBreakdownTab",
                                    allTicketData?._id
                                  )
                                }
                                // onClick={handleShow}
                              >
                                Learn more
                              </a>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="ticketDetails_Avatar">
                              {allTicketData.internalSla.groupType}
                            </div>
                            <div>{allTicketData.internalSla.message}</div>
                          </>
                        )}
                      </div>
                    </div>
                  )}

                {ticket?.isAssignee === undefined ||
                ticket?.isAssignee === true ? (
                  <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="Menu_Dots">
                        {ticket.status !== "Done" &&
                        groupTypeValue !== "md" &&
                        groupTypeValue !== "is" ? (
                          <Dropdown
                            className="MenuDotsDD"
                            drop="up"
                            align="end"
                          >
                            <Dropdown.Toggle as="div" variant="">
                              <img src={FootMenuIcon} alt="" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  handleButtonClick(ticket._id, "Reassign");
                                  resetReassignBox();
                                }}
                              >
                                Reassign Ticket
                              </Dropdown.Item>
                              {!ticket.isCritical &&
                              ticket.status !== "Done" ? (
                                <Dropdown.Item
                                  onClick={() =>
                                    handleCriticalButtonClick(ticket._id)
                                  }
                                >
                                  Mark As Critical
                                </Dropdown.Item>
                              ) : (
                                ""
                              )}
                                 {groupTypeOpExistAm ? (
                              <Dropdown.Item
                              onClick={() => {
                                handleButtonClick(ticket._id, "Irrelevant");
                                resetIrrelevantBox();
                              }}
                              >
                               
                               {allTicketData?.isIrrelevant === true ? "Mark As Relevant" : "Mark As Irrelevant"}
                               </Dropdown.Item>
                            ) : (
                              ""
                            )}
                            </Dropdown.Menu>
                          </Dropdown>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div>
                      {/* {ticket.status === "Done" ? (
                  <a role="button" className="StatusUpdateCTA" onClick={() => handleButtonClick(ticket._id, "Reopen")}>
                    Re-open Ticket
                  </a>
                ) : (
                  ""
                )} */}
                      <a
                        className="AddComment_btn"
                        onClick={() => {
                          handleButtonClick(ticket._id, "Comments");
                          resetCommentBox();
                        }}
                      >
                        <img src={AddCommentIcon} alt="" />
                        <span>Add Comment</span>
                      </a>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </>
            )}

            {activeTabDet === "details" && (
              <div className="d-flex justify-content-between">
                <div style={{ height: "29.5px" }}></div>
                <div className="d-none">
                  <a className="btn btn-dark btn_dark_outline" type="button">
                    Cancel
                  </a>
                  <a className="btn btn-dark btn_dark ms-3" type="button">
                    Save details
                  </a>
                </div>
              </div>
            )}

            {activeTabDet === "slaBreakdownTab" && (
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="Menu_Dots">
                    {ticket.status !== "Done" &&
                    groupTypeValue !== "md" &&
                    groupTypeValue !== "is" ? (
                      <Dropdown className="MenuDotsDD" drop="up" align="end">
                        <Dropdown.Toggle as="div" variant="">
                          <img src={FootMenuIcon} alt="" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => {
                              handleButtonClick(ticket._id, "Reassign");
                              resetReassignBox();
                            }}
                          >
                            Reassign Ticket
                          </Dropdown.Item>
                          {!ticket.isCritical && ticket.status !== "Done" ? (
                            <Dropdown.Item
                              onClick={() =>
                                handleCriticalButtonClick(ticket._id)
                              }
                            >
                              Mark As Critical
                            </Dropdown.Item>
                          ) : (
                            ""
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div>
                  <a
                    className="AddComment_btn"
                    onClick={() => {
                      handleButtonClick(ticket._id, "Comments");
                      resetCommentBox();
                    }}
                  >
                    <img src={AddCommentIcon} alt="" />
                    <span>Add Comment</span>
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        ""
      )}

      {showViewer &&
        allData &&
        allData.length > 0 &&
        allData[currentContainerIndex]?.attachment &&
        allData[currentContainerIndex]?.attachment.length > 0 && (
          <div className="AttachementPreviewContainer">
            {currentIndex !== 0 && isPreviousImageValid() && (
              <a className="PrevIconAttach" onClick={showPreviousImage}>
                <img src={PrevIconAttach} alt="" />
              </a>
            )}
            {currentIndex !==
              allData[currentContainerIndex].attachment.length - 1 &&
              isNextImageValid() && (
                <a className="NextIconAttach" onClick={showNextImage}>
                  <img src={NextIconAttach} alt="" />
                </a>
              )}

            {allData[currentContainerIndex]?.attachment[currentIndex]?.endsWith(
              ".pdf"
            ) ? (
              <div className="AttachementPreview">
                <div
                  className=""
                  style={{ width: "auto", position: "relative", zIndex: "1" }}
                >
                  <iframe
                    src={
                      allData[currentContainerIndex]?.attachment[currentIndex]
                    }
                  />
                  <a className="closeAttacheViewer" onClick={closeViewer}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M14 1L1 14"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M1 1L14 14"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            ) : (
              <div className="AttachementPreview">
                <div
                  className=""
                  style={{ width: "auto", position: "relative", zIndex: "1" }}
                >
                  <img
                    src={
                      allData[currentContainerIndex]?.attachment[currentIndex]
                    }
                  />
                  <a className="closeAttacheViewer" onClick={closeViewer}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M14 1L1 14"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M1 1L14 14"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            )}
            <div className="AttachmentCloseOverlay" onClick={closeViewer}></div>
          </div>
        )}
    </Fragment>
  );
};

export default Ticket;
